import React from "react";
import classNames from "classnames";
import './FormSection.scss';
import { hasValue } from "uxp/components";
export const FormSection = props => {
    const { label, error } = props;
    const styles = {};
    if (hasValue(props.inputMinWidth)) {
        styles.minWidth = props.inputMinWidth;
    }
    return React.createElement("div", { className: classNames("lucy-query-editor-form-field-b9637d36", {
            "has-error-b9637d36": hasValue(error)
        }) },
        React.createElement("div", { className: classNames("lucy-query-editor-form-field-content-b9637d36", {
                "label-top-b9637d36": props.labelPosition == 'top'
            }) },
            React.createElement("div", { className: "lucy-query-editor-form-field-label-b9637d36" }, label),
            React.createElement("div", { className: "lucy-query-editor-form-field-input-b9637d36", style: styles }, props.children)),
        hasValue(error) && React.createElement("div", { className: "lucy-query-editor-form-field-error-b9637d36" }, error));
};
